import React, { Component } from 'react';

class Loading extends Component {
    render() {
        if(this.props.show) {
            return (
                <React.Fragment>
                    <div className="loading-overlay"></div>
                    <div className="loading-card">
                        <div className="spinner-border loading-spinner" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </React.Fragment>
            );
        }else{
            return null;
        }
    }
}
 
export default Loading;